/* eslint-disable no-restricted-syntax -- these are not user-facing strings */
export type IntervalOption =
  | "monthly"
  | "annual"
  | "quarter"
  | "biannual"
  | "biweekly"
  | "weekly"
  | "daily"
  | "onetime";

export const INTERVAL_OPTIONS: readonly IntervalOption[] = [
  "monthly",
  "annual",
  "quarter",
  "biannual",
  "biweekly",
  "weekly",
  "daily",
  "onetime",
];

export const DEFAULT_INTERVAL_OPTION: IntervalOption = "monthly";
export const ONETIME: IntervalOption = "onetime";
export const SUBSCRIPTION = "subscription";

export interface IntervalMapping {
  interval: "daily" | "weekly" | "monthly" | "yearly" | undefined;
  interval_count: number | undefined;
  interval_label: IntervalOption;
}

export const INTERVAL_OPTION_MAPPER: Record<IntervalOption, IntervalMapping> = {
  daily: {
    interval: "daily",
    interval_count: 1,
    interval_label: "daily",
  },
  weekly: {
    interval: "weekly",
    interval_count: 1,
    interval_label: "weekly",
  },
  biweekly: {
    interval: "weekly",
    interval_count: 2,
    interval_label: "biweekly",
  },
  monthly: {
    interval: "monthly",
    interval_count: 1,
    interval_label: "monthly",
  },
  quarter: {
    interval: "monthly",
    interval_count: 3,
    interval_label: "quarter",
  },
  biannual: {
    interval: "monthly",
    interval_count: 6,
    interval_label: "biannual",
  },
  annual: {
    interval: "yearly",
    interval_count: 1,
    interval_label: "annual",
  },
  onetime: {
    interval: undefined,
    interval_count: undefined,
    interval_label: "onetime",
  },
};
